import { motion } from "framer-motion";

interface VoiceMatchRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
}

export function VoiceMatchRing({ score, size = 120, strokeWidth = 8 }: VoiceMatchRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (score / 100) * circumference;

  // Determine color based on score
  const getColor = () => {
    if (score >= 90) return "text-emerald-500";
    if (score >= 75) return "text-primary";
    if (score >= 60) return "text-amber-500";
    return "text-destructive";
  };

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      {/* Background Ring */}
      <svg className="absolute transform -rotate-90 w-full h-full">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          className="text-secondary"
        />
        {/* Progress Ring */}
        <motion.circle
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeLinecap="round"
          className={getColor()}
          style={{
            filter: score >= 75 ? `drop-shadow(0 0 8px currentColor)` : 'none'
          }}
        />
      </svg>
      <div className="absolute flex flex-col items-center justify-center">
        <span className="font-display font-bold text-3xl tracking-tighter">
          {score}
          <span className="text-lg text-muted-foreground ml-0.5">%</span>
        </span>
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">Match</span>
      </div>
    </div>
  );
}
